import type {
  WorkflowDeadlineBinding,
  WorkflowDeadlineRead,
} from './workflow-deadline.models';

/** A local presentation example only; this is not a provider calculation or recorded timer. */
export function syntheticDeadline(
  binding: WorkflowDeadlineBinding,
  asOfUtc: string,
): WorkflowDeadlineRead {
  const warning = new Date(Date.parse(asOfUtc) + 45 * 60_000).toISOString(),
    due = new Date(Date.parse(asOfUtc) + 60 * 60_000).toISOString();
  return {
    version: 1,
    provider: 'workflow.timer',
    sourceId: '00000000-0000-4000-8000-000000000001',
    workflowInstanceId: binding.workflowInstanceId,
    occurrenceId: binding.occurrenceId,
    definitionVersionId: binding.definitionVersionId ?? 1,
    configurationVersionId: binding.configurationVersionId ?? 1,
    definitionHash: binding.definitionHash ?? '0'.repeat(64),
    ruleCode: 'synthetic-display',
    ruleLabel: 'Synthetic deadline example',
    ruleVersion: 1,
    ruleHash: '0'.repeat(64),
    sourceRevision: 1,
    generation: 1,
    isCurrent: true,
    state: 'active',
    status: 'scheduled',
    asOfUtc,
    anchorUtc: asOfUtc,
    warningDueUtc: warning,
    breachDueUtc: due,
    calculationBreachDueUtc: due,
    remainingSeconds: 3600,
    remainingDays: null,
    countdownUnit: 'elapsed_seconds',
    dateBasis: 'recorded-occurrence-entry',
    resultExplanation:
      'Synthetic display example only. No deadline was read, calculated or saved.',
    calendarCode: null,
    calendarVersionCode: null,
    calendarContentHash: null,
    timeZoneId: 'UTC',
    route: `/workflows/${binding.workflowInstanceId}/steps/${binding.occurrenceId}`,
  };
}
